import { useState } from "react"
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReportAllLeaves from "./ReportAllLeaves";
import DailyLeave from "./DailyLeave";
import HourlyLeave from "./HourlyLeave";

import "./TabBarForLeaves.scss"


const TabBarForLeaves = () => {




  const [value, setValue] = useState(0);
  const theme = useTheme();



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function a11yProps(index) {
    return {
      id: `action-tab-${index}`,
      'aria-controls': `action-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (

      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`action-tabpanel-${index}`}
        aria-labelledby={`action-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  return (

    <div className="TabBar-container" >
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="action tabs example"
        >
          <Tab label="مرخصی روزانه" {...a11yProps(0)} />
          <Tab label="مرخصی ساعتی" {...a11yProps(1)} />
          <Tab label="مرخصی های من" {...a11yProps(2)} />
        </Tabs>
      </AppBar>





      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <DailyLeave />
        </TabPanel>




        <TabPanel value={value} index={1} dir={theme.direction}>
          <HourlyLeave />
        </TabPanel>


        <TabPanel value={value} index={2} dir={theme.direction}>
          <ReportAllLeaves />
        </TabPanel>
      </SwipeableViews>


    </div>
  )
}

export default TabBarForLeaves